import "antd/dist/antd.css"
import { SplitFactory, SplitTreatments } from "@splitsoftware/splitio-react"
import { ConfigProvider, Spin } from "antd"
import { antdConfig } from "../antd.config"
import { AuthProvider } from "../contexts/auth"
import { ErrorBoundary } from "../helpers"
import { AppDisabledMessage } from "../components/shared"
import { useEffect } from "react"
import PropTypes from "prop-types"
import { TrackingService } from "../services"
import { MixpanelTracker } from "../services/usageTrackingService/mixpanelTracker"
import moment from 'moment'
import localization from 'moment/locale/es'
import { useRouter } from 'next/router';
import LogRocket from 'logrocket';
moment.updateLocale('es', localization)

import "../styles/_globals.sass"

import { iniciarValidacionToken } from "../helpers/auth/check-token-exp"

App.propTypes = {
  Component: PropTypes.elementType,
  pageProps: PropTypes.object
}

export default function App ({ Component, pageProps }) {

  if (process.env.NODE_ENV === 'PROD') {
    console.log = () => {};
    console.warn = () => {};
    console.debug = () => {};
    console.info = () => {};
    console.error = () => {};
  }
  const router = useRouter();

  useEffect(() => {
    const logoutFlag = sessionStorage.getItem('logout_in_progress');

    if (logoutFlag) {
      sessionStorage.removeItem('logout_in_progress');

      if (router.pathname !== '/') {
        router.replace('/');
      }
    }
  }, [router.pathname]);

  useEffect(() => {
    iniciarValidacionToken();

    if (typeof window !== 'undefined' && process.env.NEXT_PUBLIC_NODE_ENV === 'PROD') {
      LogRocket.init(process.env.NEXT_PUBLIC_LOG_ROCKET);
    }
    
    const userRoles = pageProps?.userRole
      ?.replaceAll(" ", "")
      ?.split("|")
    const allowedRoles = ["LOCAL_COUNCIL", "DIRECTIVE_COUNCIL", "TECHNICAL_COMMITTEE"]

    if (pageProps.token && userRoles?.some(role => allowedRoles.includes(role))) {
      const time = moment.unix(pageProps.token.auth_time)
      const diff = moment().diff(time, "seconds")

      diff < 30 && (() => {
        TrackingService(MixpanelTracker).startTrackingSession(pageProps.token, userRoles)
        TrackingService(MixpanelTracker).trackNewLogin(pageProps.token)
      })()
    }
  }, [])

  return (
    <ConfigProvider {...antdConfig}>
      <ErrorBoundary>
        <AuthProvider>
          <SplitFactory config={{
            core: { authorizationKey: process.env.NEXT_PUBLIC_SPLIT_KEY, key: "CUSTOMER_ID" }
          }}>
            <SplitTreatments names={["DisableApp"]}>
              {({ treatments, isReady }) => (
                isReady ? (
                  treatments.DisableApp.treatment === "ON" ? <Component {...pageProps} /> : <AppDisabledMessage />
                ) : <Spin />
              )}
            </SplitTreatments>
          </SplitFactory>
        </AuthProvider>
      </ErrorBoundary>
    </ConfigProvider>
  )
}
